<template>
<div>
  <v-radio-group
    :row="true"
    v-model="val"
    @change="changeValue"
    class="lmr_category"
  >
    <v-radio :label="$t('lmr_category.infos_locales')" value="general"/>
    <v-radio :label="$t('lmr_category.sports')" value="sport"/>
    <v-radio v-if="this.$parent.consumer_group=='ebra'" :label="$t('lmr_category.magazine')" value="magazine"/>
    <v-radio v-if="this.$store.state.consumerName=='lng'" :label="$t('lmr_category.faits_divers')" value="faits_divers"/>
    <v-radio :label="$t('all')" value=""/>
  </v-radio-group>
</div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data () {
    return {
      val: ''
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
    }
  }
}
</script>
<style lang="sass">
.lmr_category
  label
    margin-bottom: 0
</style>
